// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
// import Vue from 'vue';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "babel-polyfill"
import axios from 'axios'
import pbcFun from './api/publicFun'
import App from './App'
import store from './store/store'
import echarts from 'echarts'

Vue.prototype.$echarts = echarts
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)


//轮播
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default global options } */)
// axios.defaults.baseURL = 'http://127.0.0.1:8001';
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
Vue.config.productionTip = false;

var URL='';
var imgUrl  ='';
if (process.env.NODE_ENV === 'development') {
  URL = 'http://118.196.38.138:18092';
  imgUrl='http://118.196.38.138:18092/';
  // URL = 'http://123.249.39.142:18092';
  // imgUrl='http://123.249.39.142:18092/';
  // URL = 'http://192.168.10.220:8092/';
  // urlConfig.devUrl = 'http://192.168.10.220:5082/';
}
// const URL='https://hxapi.shyunhua.com';
const fileURL='https://hxapi.shyunhua.com';
//线上地址
axios.defaults.baseURL = URL;
Vue.prototype.baseURL ="https://file.shyunhua.com/"

Vue.prototype.uploadURL = URL+'/file/upload';
// Vue.prototype.imgUrl = 'https://file.shyunhua.com/';
Vue.prototype.imgUrl = imgUrl;
window.baseURL = URL;
window.downURL = fileURL;



Vue.use(ElementUI);

// 开启debug模式
Vue.config.debug = true;
Vue.prototype.pbcFun = pbcFun;
Vue.prototype.axios = axios;


var whdef = 100/1920;
var bodyWidth = document.body.clientWidth;// 当前窗口的宽度
var rem = bodyWidth * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';

		 localStorage.setItem("shuju",rem)



//判断ie浏览器
let browserType = '', ua = navigator.userAgent;
if (/rv:11\.0/.test(ua) || /Edge/.test(ua)) {
  browserType = 'IE';
}
Vue.prototype.browserType = window.browserType = browserType;





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js